import React from 'react';

import Alert from 'common/components/Alert';
import { MessageType } from 'common/enums/Alert';

interface AlertForNoContentStepProps {
  textContent: string;
}

const AlertForNoContentStep = ({ textContent }: AlertForNoContentStepProps) => (
  <Alert mt={['sp_12', null, null, 'sp_16']} type={MessageType.Warning}>
    {textContent}
  </Alert>
);

export default AlertForNoContentStep;
